import { PayPalButton } from "react-paypal-button-v2";

export const SubscriptionPaypalBtn = (props: { amount: any; currency: any; createSubscription: any; onApprove: any; catchError: any; onError: any; onCancel: any; }) => {
    const { amount, currency, createSubscription, onApprove, catchError, onError } = props;
    const paypalKey = (process.env.NODE_ENV !== 'development') ? "AUIHYCJ8se0JnKs6ixuaHe40IU0Nt-XEE9rPUaHHLFrZ5HYYMHWYLIVq-4rNUc-47mrR9oyEYQGCqgyL" :
        "AUIHYCJ8se0JnKs6ixuaHe40IU0Nt-XEE9rPUaHHLFrZ5HYYMHWYLIVq-4rNUc-47mrR9oyEYQGCqgyL"//"Aadi2E46ysUlKYWBDURTQOkgQEsLGFS--XGDAedpqDh6TNxNVo8Z45UdicRCVUV_9zKzgqMLz-lRzLQw"
    return (
        <PayPalButton
            amount={amount}
            currency={currency}
            createSubscription={(data: any, details: any) => createSubscription(data, details)}
            onApprove={(data: any, details: any) => onApprove(data, details)}
            onError={(err: any) => onError(err)}
            catchError={(err: any) => catchError(err)}
            shippingPreference="NO_SHIPPING"
            options={{
                clientId: paypalKey,
                vault: true,
            }}
            style={{
                shape: 'rect',
                color: 'black',
                layout: 'vertical',
                label: 'paypal',
            }}
        />
    );
}
